import {
  faBackward,
  faCoins,
  faForward,
  faMoneyBillWave,
  faServer,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LoadingBox from '../components/LoadingBox'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const AdminScreen = (props) => {

  const STATUS = { STARTED: 'Traitement en cours...', }
  
    const INITIAL_COUNT1 = 300
  
    const [secondsRemaining1,            setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
    const [status1,                      setStatus1           ] = useState(STATUS.STOPPED)
  
    useEffect(()=>{
      setStatus1(STATUS.STARTED)
    },[STATUS.STARTED])

  useInterval(
    () => {
    if (secondsRemaining1 > 0) {
        setSecondsRemaining1(secondsRemaining1 - 1)
    } else {
        setStatus1(STATUS.STOPPED)
    }
    },

    status1 === STATUS.STARTED ? 1000 : null,
    // passing null stops the interval
)

function useInterval(callback, delay) {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
    savedCallback.current = callback
    }, [callback])

// Set up the interval.
useEffect(() => {
  function tick() {
    savedCallback.current()
  }
  if (delay !== null) {
    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }
}, [delay])
}

var [themeMode, setThemeMode] = useState()

let ThemeMode = localStorage.getItem("ThemeMode")

useEffect(()=>{
  
  if(secondsRemaining1 > 0){
    setThemeMode(ThemeMode)
  }

},[ThemeMode, secondsRemaining1])

  const history  = useHistory()
  var _ProWallet = localStorage.getItem('ProWallet')
  const userID   = localStorage.getItem('userID')
  const Logged   = localStorage.getItem('userStatus')
  const role     = localStorage.getItem('role')

  const [GetUser,                   setGetUser                 ] = useState([])
  const [User,                      setUser                    ] = useState([])
  const [operatorList,              setOperatorList            ] = useState([])
  const [cinetPayApi,               setCinetPayApi             ] = useState([])
  const [passwordApi,               setPasswordApi             ] = useState([])
  const [ownSiteId,                 setOwnSiteId               ] = useState([])
  const [alertOptions,              setAlertOptions            ] = useState()
  const [oneDisplay,                setOneDisplay              ] = useState()
  const [operatorDisplay,           setOperatorDisplay         ] = useState()
  const [rateDisplay,               setRateDisplay             ] = useState()
  const [usersDisplay,              setUsersDisplay            ] = useState()
  const [cryptoMarker,              setCryptoMarker            ] = useState('')
  const [operatorMarker,            setOperatorMarker          ] = useState('')
  const [rateMarker,                setRateMarker              ] = useState('')
  const [usersMarker,               setUsersMarker             ] = useState('')
  const [counterMarker,             setCounterMarker           ] = useState('')
  const [cryptocounterMarker,       setCryptoCounterMarker     ] = useState('')
  const [orderConfirmationData,     setOrderConfirmationData   ] = useState([])
  const [Operation,                 setOperation               ] = useState([])

  const [isActivated,               setIsActivated             ] = useState()
  const [activeStatus,              setActiveStatus            ] = useState()



  const activationId = props.location.hash.slice(1, 25)


  if (_ProWallet === 'true') {
    props.history.push('/nkab-pro')
  }

  if (Logged !== 'Logged') {
    props.history.push('/login')
  }

  if (Number(role) !== 1) {
    props.history.push('/')
  }



  useEffect(()=>{

    const fetchDada12 = async () => {
      try {
        const { data } = await axios.get(
          '/api/v1/get-users',
        )
        setGetUser(data)
      } catch (error) {}
    }
    fetchDada12()

  },[])

  useEffect(()=>{

    if(GetUser && userID){
      const userGetted = GetUser.filter((obj) => {
        return obj.ID === Number(userID)
      })
      setUser(userGetted[0])
    }

  },[GetUser, userID, User])





  const buy_btc_taux = 665
  const sell_btc_taux = 610

  const buy_tron_taux = 658
  const sell_tron_taux = 615

  const buy_ltc_taux = 658
  const sell_ltc_taux = 615

  const buy_doge_taux = 658
  const sell_doge_taux = 615

  const buy_bsc_taux = 655
  const sell_bsc_taux = 615

  const buy_usdt_taux = 655
  const sell_usdt_taux = 615

  const buy_Payeer_taux = 668
  const sell_Payeer_taux = 623

  const buy_PM_taux = 659
  const sell_PM_taux = 580
  
  const buy_busd_taux = 659
  const sell_busd_taux = 615

  const buy_shiba_taux = 658
  const sell_shiba_taux = 615

  const buy_polygonmatic_taux = 658
  const sell_polygonmatic_taux = 615

  const buy_ethereum_taux = 658
  const sell_ethereum_taux = 615

  const buy_pokadot_taux = 658
  const sell_pokadot_taux = 615

  const buy_chainlink_taux = 658
  const sell_chainlink_taux = 615

  const buy_cardano_taux = 658
  const sell_cardano_taux = 615

  const buy_solana_taux = 658
  const sell_solana_taux = 615


  


  useEffect(() => {

    const fetchCinetPayApiDada = async () => {
      try {
        const { data } = await axios.get(
          '/api/v1/get-cinetpay-api',
        )
        setCinetPayApi(data[0])
      } catch (error) {}

      try {
        const { data } = await axios.get(
          '/api/v1/get-api-pwd',
        )
        setPasswordApi(data[0])
      } catch (error) {}

      try {
        const { data } = await axios.get(
          '/api/v1/get-siteids',
        )
        setOwnSiteId(data[0])
      } catch (error) {
        console.log(error)
      }
    }
    fetchCinetPayApiDada()

  }, [])

  useEffect(() => {

    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          '/api/v1/operations',
        )
        if(data.length > 0){
          setOperation(data)
          setOrderConfirmationData(data)
        }
        
      } catch (error) {}
    }

    fetchData()

  }, [Operation])

  function activationHandler() {
    axios.post(
        `/api/v1/services/update`,
        {
          activationId : Number(activationId),
          isActivated : Number(isActivated),
        },
      )
      .then(
        (response) => {
          setAlertOptions(response.data)
        },
        (error) => {
          console.log(error)
        },
      )
  }

  function activateHandler() {
    setIsActivated(1)
    if (isActivated === 1 && activationId) {
      activationHandler()
    }
  }
  function desactivateHandler() {
    setIsActivated(0)
    if (isActivated === 0 && activationId) {
      activationHandler()
    }
  }

  function alerter() {
    setAlertOptions()
    props.history.push('/#action=dashboard')
  }



  useEffect(() => {
    if (alertOptions) {
      if (alertOptions.isActivated === 1) {
        setActiveStatus('Activé')
        if (activeStatus === 'Activé') {
          alertHandler()
        }
      } else if (alertOptions.isActivated === 0) {
        setActiveStatus('Désactivé')
        if (activeStatus === 'Désactivé') {
          alertHandler()
        }
      }
    }
  }, [])

  function alertHandler() {
    confirmAlert({
      title: `${alertOptions.serviceName}${' '}${activeStatus}`,
      buttons: [
        {
          label: 'Ok',
          onClick: () => alerter(),
        },
      ],
    })
  }

  function cryptoHandler() {
    setOneDisplay(true)
    setCryptoMarker('options-item-bg')
    setRateMarker('')
    setUsersMarker('')
    setOperatorMarker('')
    setCounterMarker('')
    setCryptoCounterMarker('')

    setOperatorDisplay(false)
    setRateDisplay(false)
    setUsersDisplay(false)
  }

  function operatorHandler() {
    setOperatorDisplay(true)
    setOperatorMarker('options-item-bg')
    setRateMarker('')
    setUsersMarker('')
    setCryptoMarker('')
    setCounterMarker('')
    setCryptoCounterMarker('')
    setOneDisplay(false)
    setRateDisplay(false)
    setUsersDisplay(false)
  }

  function rateHandler() {
    setRateDisplay(true)
    setRateMarker('options-item-bg')
    setCryptoMarker('')
    setUsersMarker('')
    setOperatorMarker('')
    setCounterMarker('')
    setCryptoCounterMarker('')
    setOperatorDisplay(false)
    setOneDisplay(false)
    setUsersDisplay(false)
  }

  function usersHandler() {
    setUsersDisplay(true)
    setUsersMarker('options-item-bg')
    setCryptoMarker('')
    setRateMarker('')
    setOperatorMarker('')
    setCounterMarker('')
    setCryptoCounterMarker('')
    setRateDisplay(false)
    setOperatorDisplay(false)
    setOneDisplay(false)
  }

  function counterHandler() {
    setCounterMarker('options-item-bg')
    setUsersMarker('')
    setCryptoMarker('')
    setRateMarker('')
    setOperatorMarker('')
    setCryptoCounterMarker('')
    setRateDisplay(false)
    setOperatorDisplay(false)
    setOneDisplay(false)
    setUsersDisplay(false)
  }

  function cryptocounterHandler() {
    setCounterMarker('')
    setUsersMarker('')
    setCryptoMarker('')
    setRateMarker('')
    setOperatorMarker('')
    setCryptoCounterMarker('options-item-bg')
    setRateDisplay(false)
    setOperatorDisplay(false)
    setOneDisplay(false)
    setUsersDisplay(false)
  }

  useEffect(()=>{
    const fetchOperators = async () => {
    try {
        const { data } = await axios.get(
          '/api/v1/get-money-operators',
        )
        if(data.length > 0){
          setOperatorList(data)
        }
    } catch (error) {}

  }
  fetchOperators()
  },[])


  const loadServicesMsg =  "Chargement de services en cours..."
  const loadOperationMsg =  "Chargement d'opération en cours..."
  

  const serviceLists = [
    {
      ID: 1,
      isActivated: 1,
      serviceImageLink: "../images/usdt.png",
      serviceName: "Tether(USDT)",
      serviceSymbol: "USDT"
    },
    {
      ID: 2,
      isActivated: 1,
      serviceImageLink: "../images/bnb.png",
      serviceName: "Binance Smart Chain",
      serviceSymbol: "BNB"
    },
    {
      ID: 3,
      isActivated: 1,
      serviceImageLink: "../images/btc.png",
      serviceName: "Bitcoin",
      serviceSymbol: "BTC"
    },
    {
      ID: 4,
      isActivated: 1,
      serviceImageLink: "../images/ltc.png",
      serviceName: "Litecoin",
      serviceSymbol: "LTC"
    },
    {
      ID: 5,
      isActivated: 1,
      serviceImageLink: "../images/doge.png",
      serviceName: "Dogecoin",
      serviceSymbol: "DOGE"
    },
    {
      ID: 6,
      isActivated: 1,
      serviceImageLink: "../images/payeer.png",
      serviceName: "Payeer",
      serviceSymbol: "PAYEER"
    },
    {
      ID: 7,
      isActivated: 1,
      serviceImageLink: "../images/pm.png",
      serviceName: "Perfect Money",
      serviceSymbol: "PM"
    },
    {
      ID: 8,
      isActivated: 1,
      serviceImageLink: "../images/tron.png",
      serviceName: "TRON",
      serviceSymbol: "trx"
    },
    {
      ID: 9,
      isActivated: 1,
      serviceImageLink: "../images/busd.png",
      serviceName: "Binance USD",
      serviceSymbol: "BUSD"
    },
    {
      ID: 10,
      isActivated: 1,
      serviceImageLink: "../images/shiba.png",
      serviceName: "Shiba Inu",
      serviceSymbol: "SHIB"
    },
    {
      ID: 11,
      isActivated: 1,
      serviceImageLink: "../images/polygonmatic.png",
      serviceName: "Polygon",
      serviceSymbol: "MATIC"
    },
    {
      ID: 12,
      isActivated: 1,
      serviceImageLink: "../images/eth.png",
      serviceName: "Ethereum",
      serviceSymbol: "ETH"
    },
    {
      ID: 13,
      isActivated: 1,
      serviceImageLink: "../images/pokadot.png",
      serviceName: "Polkadot",
      serviceSymbol: "DOT"
    },
    {
      ID: 14,
      isActivated: 1,
      serviceImageLink: "../images/chainlink.png",
      serviceName: "Chainlink",
      serviceSymbol: "LINK"
    },
    {
      ID: 15,
      isActivated: 1,
      serviceImageLink: "../images/cardano.png",
      serviceName: "Cardano",
      serviceSymbol: "ADA"
    },
    {
      ID: 16,
      isActivated: 1,
      serviceImageLink: "../images/solana.png",
      serviceName: "Solana",
      serviceSymbol: "SOL"
    },
  ]

  return (
    <div className="container mt-5">
      <div className="main-session">
        <div className="d-flex justify-content-between keys-session">
          <span className="cinetpay-api">
            {!cinetPayApi ? null : cinetPayApi ? (
              <>
                {' '}
                {'CinetPay API :'} {cinetPayApi.cinetPayAPI}{' '}
              </>
            ) : null}
          </span>
          <span className="cinetpay-api">
            {!passwordApi ? null : passwordApi ? (
              <>
                {' '}
                {'API Password :'} {passwordApi.aPIPassword}{' '}
              </>
            ) : null}
          </span>
          <span className="cinetpay-api">
            {!ownSiteId ? null : ownSiteId ? (
              <>
                {' '}
                {'Site ID :'} {ownSiteId.siteId}{' '}
              </>
            ) : null}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <div style={{ marginBottom: `${'10px'}` }}>
            <span
              className='goback'
              onClick={() => history.goBack()}
              style={{ color: '#0a146e', cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faBackward} /> {'Retour'}
            </span>
          </div>
          <div style={{ marginBottom: `${'10px'}` }}>
            <a href="/sell-or-buy-crypto" style={{textDecoration:"none"}}>
              <span
                type="submit"
                className='goback'
                style={{ color: '#0a146e', cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={faForward} /> {'Accueil du service'}
              </span>
            </a>
          </div>
        </div>
      </div>

      <section className="">
        <div className="d-flex">
          <div className="admin-options-side">
            <div className="admin-options-side-title">Menu d'options</div>
            <div
              className={`admin-options-item ${cryptoMarker}`}
              onClick={cryptoHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Crypto Actifs</span>
            </div>
            <div
              className={`admin-options-item ${operatorMarker}`}
              onClick={operatorHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Opérateur Réseau</span>
            </div>
            <div
              className={`admin-options-item ${rateMarker}`}
              onClick={rateHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Mise à jour Taux</span>
            </div>
            <div
              className={`admin-options-item ${usersMarker}`}
              onClick={usersHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Utilisateurs</span>
            </div>
            <div
              className={`admin-options-item ${counterMarker}`}
              onClick={counterHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Mise à jour Mobile Money</span>
            </div>
            <div
              className={`admin-options-item ${cryptocounterMarker}`}
              onClick={cryptocounterHandler}
            >
              <span className="admin-option-button" style={{fontSize:'13.5px'}}>Mise à jour Réserves Crypto</span>
            </div>
          </div>
          <div className="admin-display-side table-section">
            {oneDisplay === true ? (
              <div>
                <a href="/newservice" className="admin-add-crypto my_rate_button">
                  Crypto actif <strong className="color-white">+</strong>
                </a>
                <div className="_admin-display-card-section pt-3">
                  {!serviceLists ? <LoadingBox loadServicesMsg={loadServicesMsg} /> : serviceLists.map((item) => (
                    <div key={item.ID} className='di'>
                      {item.serviceSymbol === 'ntr' ? null : (
                        <div className="card admin-display-card">
                          <div className="crypto-card-img-container">
                            <img
                              src={item.serviceImageLink}
                              className="crypto-card-img"
                              alt={item.serviceName}
                            />
                          </div>
                          <div className="card-body">
                            <h5 className="card-title">{item.serviceName}</h5>
                            <p className="card-text color-r">
                              Cliquer deux fois pour activer ou désactiver la
                              monnaie si le statut ne change pas!
                            </p>
                            <div className="d-flex justify-content-center">
                              {item.isActivated === 1 ? (
                                <a
                                  href={`#${item.ID}`}
                                  className="btn btn-success admin-display-button ml-2 mr-2"
                                  style={{backgroundColor:'#157347'}}
                                  onClick={desactivateHandler}
                                >
                                  Activé
                                </a>
                              ) : item.isActivated === 0 ? (
                                <a
                                  href={`#${item.ID}`}
                                  className="btn btn-secondary admin-display-button ml-2 mr-2"
                                  style={{backgroundColor:'#4e4e4e'}}
                                  onClick={activateHandler}
                                >
                                  Désactivé
                                </a>
                              ) : null}
                              <a
                                href={`#${item.ID}`}
                                className="btn btn-danger admin-display-button ml-2 mr-2"
                                style={{backgroundColor:'#bb2d3b'}}
                                // onClick={deleteServiceHandle}
                              >
                                Supprimer
                              </a>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : operatorDisplay === true ? (
              <div>
                <div className='row'>
                  <div className='col-md-2 mb-3 mt-2'>
                    <a href="/newoperator" className="admin-add-crypto my_rate_button">
                      Paiement <strong className="color-white">+</strong>
                    </a>
                  </div>
                </div>
                <div className="_admin-display-card-section pt-3">
                  {!operatorList ? <LoadingBox loadServicesMsg={loadOperationMsg} /> : operatorList.map((item) => (
                    <div key={item.ID}>
                      {item.operatorSymbol === 'XXX' ? null : (
                        <div className="text-center align-items-center card admin-display-card">
                          <div className='p-2'>
                            <img src={item.operatorImageLink} className="crypto-card-img" alt={item.operatorName} />
                          </div>
                          <div className="card-body">
                            <h5 className="card-title">{item.operatorName}</h5>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : rateDisplay === true ? (
              <div className="_admin-display-card-section pt-3">
                {!serviceLists ? <LoadingBox loadServicesMsg={loadServicesMsg} /> : serviceLists.map((item) => (
                  <div key={item.ID}>
                    {item.serviceSymbol === 'ntr' ? null : (
                      <div className="card admin-display-card">
                        <div className="card-body">
                          <div className="text-center pt-3">
                            <img src={item.serviceImageLink} className="crypto-card-img" alt={item.serviceName}
                            />
                          </div>
                          <div className="text-center">
                            <h5 className="admin-display-rate-content"> {item.serviceName} </h5>
                            <div>
                              {item.serviceSymbol === 'BTC' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_btc_taux} CFA {' '} </span>
                                </p>
                              ) :item.serviceSymbol === 'trx' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_tron_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'LTC' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_ltc_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'DOGE' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_doge_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'BUSD' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_busd_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'SHIB' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_shiba_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'MATIC' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_polygonmatic_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'ETH' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_ethereum_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'DOT' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_pokadot_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'LINK' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_chainlink_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'ADA' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_cardano_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'SOL' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {buy_solana_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'BNB' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_bsc_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'USDT' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_usdt_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'PAYEER' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_Payeer_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'PM' ? (
                                  <p className="admin-display-rate-content">
                                    Taux d'Achat <br/>
                                    <span className="service-rate"> {buy_PM_taux} CFA {' '} </span>
                                  </p>
                              ) : null}
                            </div>
                            <div>
                              {item.serviceSymbol === 'BTC' ? (
                                <p className="admin-display-rate-content">
                                  Taux de Vente <br/>
                                  <span className="service-rate"> {sell_btc_taux} CFA {' '} </span>
                                </p>
                              ) :item.serviceSymbol === 'trx' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_tron_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'LTC' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_ltc_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'DOGE' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_doge_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'BUSD' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_busd_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'SHIB' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_shiba_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'MATIC' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_polygonmatic_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'ETH' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_ethereum_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'DOT' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_pokadot_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'LINK' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_chainlink_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'ADA' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_cardano_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'SOL' ? (
                                <p className="admin-display-rate-content">
                                  Taux d'Achat <br/>
                                  <span className="service-rate"> {sell_solana_taux} CFA {' '} </span>
                                </p>
                              ) : item.serviceSymbol === 'BNB' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_bsc_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'USDT' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_usdt_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'PAYEER' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_Payeer_taux} CFA {' '} </span>
                                  </p>
                              ) : item.serviceSymbol === 'PM' ? (
                                  <p className="admin-display-rate-content">
                                    Taux de Vente <br/>
                                    <span className="service-rate"> {sell_PM_taux} CFA {' '} </span>
                                  </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : usersDisplay === true ? (
              <div className="admin-display-sell-section">

              <div className="__op-body-table">
                <table className='__op-responsive-table'>
                  <thead>
                    <tr>
                      <th scope="col">Email</th>
                      <th scope="col">Nom</th>
                      <th scope="col">Prénoms</th>
                      <th scope="col">Contact</th>
                      <th scope="col">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                  {GetUser.length > 0 && GetUser.map((item) => (
                    <tr key={item.ID}>
                      <th scope="row" style={{color:"#c7b301"}}>{item.email}</th>
                      <td data-title="Nom">{item.name}</td>
                      <td data-title="Prénoms">{item.lastName}</td>
                      <td data-title="Contact">{item.telNumber}</td>
                      <td data-title="Date">{item.updatedAt.slice(0,10)} à {Number(item.updatedAt.slice(11,13)) + 2}{item.updatedAt.slice(13,19)}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
              </div>
            ) : (
              <div className="p-2">
                <div className="row mb-4">
                  <div className='col-md-3 d-flex justify-content-around'>
                    <div className='mr-2'><FontAwesomeIcon icon={faUserCircle} style={{ fontSize: 40, color: `${'#7a9fc7'}` }} /></div>
                    <div className="card-body">
                      <h5 className="card-title">Utilisateurs</h5>
                      <p className="card-text color-r">
                        {
                          !GetUser?null:GetUser.length > 0 ? 
                          ( <span> <strong className="strong-length"> {!GetUser?null:GetUser.length} </strong> </span> ) :
                          ( <span> 0 </span> )
                        }
                      </p>
                    </div>
                  </div>
                  <div className='col-md-3  d-flex justify-content-around'>
                    <div className='mr-2'><FontAwesomeIcon icon={faServer} style={{ fontSize: 40, color: `${'#7a9fc7'}` }} /></div>
                    <div className="card-body">
                      <h5 className="card-title">Opérations</h5>
                      <p className="card-text color-r">
                        {
                          !Operation?null:Operation.length > 0 ? 
                          ( <span> <strong className="strong-length"> {!Operation?null:Operation.length} </strong> </span> ) :
                          ( <span> 0 </span> )
                        }
                      </p>
                    </div>
                  </div>
                  <div className='col-md-3  d-flex justify-content-around'>
                    <div className='mr-2'><FontAwesomeIcon icon={faCoins} style={{ fontSize: 40, color: `${'#7a9fc7'}` }} /></div>
                    <div className="card-body">
                      <h5 className="card-title">Crypto Actifs</h5>
                      <p className="card-text color-r">
                        {
                          !serviceLists?null:serviceLists.length > 0 ? 
                          ( <span> <strong className="strong-length"> {!serviceLists?null:serviceLists.length} </strong> </span> ) :
                          ( <span> 0 </span> )
                        }
                      </p>
                    </div>
                  </div>
                  <div className='col-md-3  d-flex justify-content-around'>
                    <div className='mr-2'><FontAwesomeIcon icon={faMoneyBillWave} style={{ fontSize: 40, color: `${'#7a9fc7'}` }} /></div>
                    <div className="card-body">
                      <h5 className="card-title">Moyens de paiement</h5>
                      <p className="card-text color-r">
                        {
                          !operatorList?null:operatorList.length > 0 ? 
                          ( <span> <strong className="strong-length"> {!operatorList?null:operatorList.length} </strong> </span> ) :
                          ( <span> 0 </span> )
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default AdminScreen
